import { combineReducers } from "redux";

import { organizationsSlice } from "./organizations.slice";
import { organizationDefaultWorkspaceSettingsSlice } from "./organizationWorkspaceDefaultSettings.slice";

export const organizationReducerMap = {
	organizations: organizationsSlice.reducer,
	organizationDeviceSettings: organizationDefaultWorkspaceSettingsSlice.reducer,
};

const reducers = combineReducers(organizationReducerMap);

export type OrganizationState = ReturnType<typeof reducers>;
